import { Schema, TextField, DateTimeField } from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";

export const CallLogSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  defaultSort: { sort: "callTimestamp", order: "desc" },
  fields: [
    {
      name: "callTimestamp",
      type: DateTimeField(),
      title: t("hns:callLog:timestamp")
    },
    {
      name: "calling",
      type: TextField(),
      title: t("hns:callLog:calling")
    },
    {
      name: "called",
      type: TextField(),
      title: t("hns:callLog:called")
    },
    {
      name: "translated",
      type: TextField(),
      title: t("hns:callLog:translated")
    },
    {
      name: "conversationDuration",
      type: TextField(),
      title: t("hns:callLog:conversationDuration")
    },
    {
      name: "totalDuration",
      type: TextField(),
      title: t("hns:callLog:totalDuration")
    },
    {
      name: "treatmentDuration",
      type: TextField(),
      title: t("hns:callLog:treatmentDuration")
    }
  ]
});

mainStore.callLog = RemoteChildDataSource.create({
  parent: mainStore.SAN.oneDataSource,
  dtoStrategy: queryParamDtoStrategy("id", "sanRef"),
  parentChangedStrategy: queryParamParentChangeStrategy("id", "sanRef"),
  api: api,
  name: "callLog",
  schema: CallLogSchema,
  url: "/callLogs",
  commons: mainStore.commons
});
